//export const baseApiURL = 'https://vivot-fix-server.herokuapp.com';
export const baseApiURL = 'https://ecosistema-vivot.herokuapp.com'
